import { ResourceType } from '../types/ResourceType';
import { GetResourceTypeListingSchema } from '../schemas/ResourceTypeZodSchema';

/**
 * Transforms and validates the response from the getResourceTypeListing GraphQL query
 * to a simplified ResourceType type.
 *
 * @param data The response data from the getResourceTypeListing query
 * @returns An array of valid ResourceType objects
 */
export function transformResourceTypeResponse(
    data?: unknown // GetResourceTypeListingQuery - use unknown for jest tests be
    // able to pass invalid data
): ResourceType[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetResourceTypeListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error('Validation failed for getResourceTypeListing:', parsedResult.error.errors);
        return [];
    }

    const parsedGroups = parsedResult.data.getObjectFolder.children;

    // Transform resource type groups and types to simplified hierarchical ResourceType type
    const resourceTypes: ResourceType[] = [];
    parsedGroups.forEach((parsedGroup) => {
        const resourceType: ResourceType = {
            id: parsedGroup.id,
            key: parsedGroup.key,
            name: parsedGroup.name,
            children: [],
        };
        resourceType.children = parsedGroup.resourceTypes.map((parsedType) => {
            return {
                id: parsedType.id,
                key: parsedType.key,
                name: parsedType.name,
                parent: resourceType,
            };
        });
        resourceTypes.push(resourceType);
    });

    return resourceTypes;
}
